import { FileAttachmentClass } from '../../Class/common/file-attachment/file-attachment-class';

export class Da9000Class {
    FileId: number;
    FileNameSelected: string;
    FileNameServer: string;
    Folder: string;
    FkPageId: number;
    PageName: string;
    TableName: string;
    AutoId: number;
    CrtdBy: number;
    CrtdOn: Date;
    AttachmentList:  Array<FileAttachmentClass> = [];
}

